import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; // 引入 useNavigate 用于跳转

const Signup = () => {
  const [firstname, setFirstname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState(""); // 新增：成功提示

  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("login-body");
    return () => {
      document.body.classList.remove("login-body");
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    // 前端基础校验
    if (!firstname.trim() || !email.trim() || !password.trim() || !repeatPassword.trim()) {
      setErrorMessage("All fields are required");
      return;
    }
    if (password.length < 8) {
      setErrorMessage("Password must have at least 8 characters");
      return;
    }
    if (password !== repeatPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }

    try {
      // 🌟 修改点 1：使用你最新的域名和规范化路径
      // 注意：既然已经有了 CDN，这里直接写 https 域名
      const response = await axios.post('/signup/signup', {
        firstname,
        email,
        password,
        repeat_password: repeatPassword
      });

      // 🌟 修改点 2：处理“激活邮件”逻辑
      // 注册成功后不要立刻登录，而是提示用户去查收邮件
      setSuccessMessage("Registration successful! Please check your email to verify your account.");

      // 3秒后自动跳转到登录页面，让用户等待激活后登录
      setTimeout(() => {
        navigate("/login");
      }, 5000);

    } catch (error) {
      // 🌟 修改点 3：优化错误捕获，FastAPI 返回的错误通常在 error.response.data.detail 中
      const errorDetail = error.response?.data?.detail;
      setErrorMessage(typeof errorDetail === 'string' ? errorDetail : "Signup failed. Please try again.");
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="Sign Up">Sign Up</h1>

      {/* 错误提示 */}
      {errorMessage && <p className="error-message" style={{color: 'red'}}>{errorMessage}</p>}

      {/* 🌟 成功提示：告诉用户去翻邮箱 */}
      {successMessage && (
        <div className="success-message" style={{color: 'green', backgroundColor: '#e6fffa', padding: '10px', borderRadius: '5px', marginBottom: '10px'}}>
          {successMessage}
        </div>
      )}

      <form id="login-form" className="login-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <label htmlFor="firstname-input">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Z"/>
            </svg>
          </label>
          <input
            type="text"
            id="firstname-input"
            placeholder="Firstname"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            disabled={!!successMessage} // 成功后禁用输入
          />
        </div>
        <div className="input-group">
          <label htmlFor="email-input">@</label>
          <input
            type="email"
            id="email-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={!!successMessage}
          />
        </div>
        <div className="input-group">
          <label htmlFor="password-input">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z"/>
            </svg>
          </label>
          <input
            type="password"
            id="password-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={!!successMessage}
          />
        </div>
        <div className="input-group">
          <label htmlFor="repeat-password-input">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z"/>
            </svg>
          </label>
          <input
            type="password"
            id="repeat-password-input"
            placeholder="Repeat Password"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            disabled={!!successMessage}
          />
        </div>
        <button type="submit" className="submit-btn" disabled={!!successMessage}>
          {successMessage ? "Redirecting..." : "Sign Up"}
        </button>
      </form>
      <p>
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
};

export default Signup;